export function curry(fn) {
    const arity = fn.length;
    if (arity === 0)
        return fn;
    return (...args) => {
        const len = args.length;
        if (len === 0)
            return fn;
        // NOTE: These switches are ugly but they exist for a reason. They can
        //  dramatically speed up the most common cases (arity < 5) calls b/c
        //  Function#apply is much slower than either direct calls or Function#call.
        //  So, it's ugly, but for utility code, it's fine. Knowing this, it is
        //  strange that browser Function#apply implementations don't use a
        //  similar heuristic.
        if (len >= arity) {
            switch (arity) {
                case 1:
                    return fn(args[0]);
                case 2:
                    return fn(args[0], args[1]);
                case 3:
                    return fn(args[0], args[1], args[2]);
                case 4:
                    return fn(args[0], args[1], args[2], args[3]);
                case 5:
                    return fn(args[0], args[1], args[2], args[3], args[4]);
                default:
                    return fn(...args);
            }
        }
        let bound;
        switch (len) {
            case 1:
                bound = fn.bind(null, args[0]);
                break;
            case 2:
                bound = fn.bind(null, args[0], args[1]);
                break;
            case 3:
                bound = fn.bind(null, args[0], args[1], args[2]);
                break;
            case 4:
                bound = fn.bind(null, args[0], args[1], args[2], args[3]);
                break;
            default:
                bound = fn.bind(null, ...args);
                break;
        }
        return curry(bound);
    };
}
//# sourceMappingURL=curry.js.map